import { SET_ACTIVE_ITEM } from './constants';

/* eslint-disable */
export function setActiveItem(activeItem) {
  return {
    type: SET_ACTIVE_ITEM,
    activeItem,
  };
}




// WEBPACK FOOTER //
// ./src/Modules/Navigation/actions.js